// src/shared/components/HomeHeader.jsx
import { Box, IconButton, Typography, Stack, useMediaQuery, useTheme } from "@mui/material";
import { useEffect, useRef } from "react";
import PageShell from "./PageShell";
import SouthIcon from "@mui/icons-material/South";
import headerImg from '../../assets/Header.svg';
import headerVideo from '../../assets/Video/Bacterias_animadas_H.mp4'
import headerVideoV from '../../assets/Video/Bacterias_animadas_V.mp4'

export default function HomeHeader({ id = "home-page-title", image = headerImg }) {
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));
    const videoRef = useRef(null);

    useEffect(() => {
        const video = videoRef.current;
        if (!video) return;

        const handleScroll = () => {
            // Pequeño delay para asegurar que el layout esté listo en desktop
            setTimeout(() => {
                video.scrollIntoView({ block: "end" });
            }, 100);
        };

        if (video.readyState >= 1) {
            handleScroll();
        } else {
            video.addEventListener("loadedmetadata", handleScroll);
        }

        return () => {
            video.removeEventListener("loadedmetadata", handleScroll);
        };
    }, [isSmallScreen]);

    return (
        <Box sx={{ width: "100%", bgcolor: "#000", display: "flex", justifyContent: "center" }}>
            <Box sx={{ width: "100%", maxWidth: "1920px", position: "relative" }}>
                <Box
                    component="video"
                    ref={videoRef}
                    src={isSmallScreen ? headerVideoV : headerVideo}
                    key={isSmallScreen ? "video-vertical" : "video-horizontal"}
                    autoPlay
                    loop
                    muted
                    playsInline
                    sx={{
                        width: "100%",
                        height: "auto",
                        display: "block",
                        zIndex: 0
                    }}
                />
            </Box>
        </Box>
    );
}
